module.exports = __webpack_public_path__ + "static/media/6030.28143207.jpg";